import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.date.to-string";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.define-property";
import "core-js/modules/es.object.to-string";
import { __assign, __awaiter, __decorate, __extends, __generator } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import { enumData, loading } from '@/decorators';
import { namespace } from 'vuex-class';
import Anchor from '@/components/anchor/index.vue';
var User = namespace('user');

var AddEditCopyPackaging = function (_super) {
  __extends(AddEditCopyPackaging, _super);

  function AddEditCopyPackaging() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.packagingCategoryEnum = [];
    _this.productTypeEnum = [];
    _this.labelCol = {
      span: 6
    };
    _this.wrapperCol = {
      span: 18
    };
    _this.formData = _this.initFormData();
    _this.importCountryList = [];
    _this.addLoading = false;
    _this.detailLoading = false;
    _this.imageTipMessage = '';
    _this.formDataRule = _this.initFormDataRule();
    _this.sizeReg = /^(([0-9]{1}\d*)|(0{1}))(\.\d{0,2})?$/;
    _this.weightReg = /^(([0-9]{1}\d*)|(0{1}))(\.\d{0,3})?$/;
    _this.weightRange = {
      MIN: 0.001,
      MAX: 9999.999
    };
    _this.productSkuReg = /^[0-9A-Za-z_\-./+*&()]{1,80}$/;
    _this.barcodeReg = /^[0-9A-Za-z_\-./+*&()]{1,50}$/;
    _this.chineseReg = /[\u4e00-\u9fa5]/;
    _this.anchorList = [];
    return _this;
  }

  Object.defineProperty(AddEditCopyPackaging.prototype, "pageTitle", {
    get: function get() {
      switch (this.type) {
        case 'edit':
          return this.t('编辑包材');

        case 'copy':
          return this.t('复制包材');

        default:
          return this.t('新增商品');
      }
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(AddEditCopyPackaging.prototype, "isBox", {
    get: function get() {
      return this.formData.basics_info.packaging_type === this.$enum.product.PackagingCategoryMap.BOX;
    },
    enumerable: false,
    configurable: true
  });

  AddEditCopyPackaging.prototype.setAnchorList = function () {
    var list = [{
      title: this.t('基本信息'),
      href: '#packagingBaseMsg'
    }];

    if (this.isShowMapBarcode) {
      list.push({
        title: this.t('映射信息'),
        href: '#packagingMappingMsg'
      });
    }

    list.push({
      title: this.t('规格信息'),
      href: '#packagingSpecMsg'
    });
    list.push({
      title: this.t('进口信息'),
      href: '#packagingCustomsMsg'
    });
    list.push({
      title: this.t('其他信息'),
      href: '#packagingOtherMsg'
    });
    this.anchorList = list.map(function (item, index) {
      item.title = index + 1 + ' ' + item.title;
      return item;
    });
  };

  AddEditCopyPackaging.prototype.getContainer = function () {
    return document.querySelector('.layout-main');
  };

  AddEditCopyPackaging.prototype.handleProductTypeSwitchChange = function (e) {
    var value = e.target.value;

    if (value === this.$enum.product.ProductTypeMap.PRODUCT) {
      this.$emit('product-type-change', value);
    }
  };

  Object.defineProperty(AddEditCopyPackaging.prototype, "isShowMapBarcode", {
    get: function get() {
      return !!this.customerInfo.third_party_barcode_service;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(AddEditCopyPackaging.prototype, "skuEditable", {
    get: function get() {
      return this.type === 'edit' && this.formData.product_status !== this.$enum.product.ProductStatusEnum.DRAFT;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(AddEditCopyPackaging.prototype, "imageList", {
    get: function get() {
      return this.formData.image_list.map(function (item) {
        return {
          uid: item.preview_url,
          url: item.preview_url,
          name: item.file_name
        };
      });
    },
    enumerable: false,
    configurable: true
  });

  AddEditCopyPackaging.prototype.initFormData = function () {
    return {
      product_id: '',
      product_status: '',
      basics_info: {
        product_sku: '',
        reference_number: '',
        product_name_cn: '',
        product_name_en: '',
        product_declared_name_cn: '',
        product_declared_name_en: '',
        product_url: '',
        category_third_id: undefined,
        goods_attribute: undefined,
        product_package_type: this.$enum.product.ProductPackageTypeEnum.PACKAGE,
        is_brand: this.$enum.common.BoolIntEnum.NO,
        product_brand: '',
        product_model: '',
        product_function: '',
        product_material: '',
        unit_id: '',
        category_language: '',
        sku_wrapper_type: this.$enum.product.ProductSkuWrapperTypeEnum.PRE_WRAPPER,
        return_value_add_service_list: [],
        return_replacement_sku: '',
        product_type: this.$enum.product.ProductTypeMap.PACKAGING,
        packaging_type: undefined,
        spread_length: '',
        spread_width: '',
        spread_height: ''
      },
      spec_info: {
        product_length: '',
        product_width: '',
        product_height: '',
        product_weight: '',
        predict_pcs_inner: null
      },
      export_country_list: [{
        country_code: 'CN',
        declared_value: '0.01'
      }],
      import_country_list: [],
      image_list: [],
      certification_list: [],
      other_info: {
        remark: ''
      },
      map_barcode_list: [''],
      is_whether_batch_management: this.$enum.common.BoolIntEnum.NO,
      batch_comb_code: '',
      batch_info: {
        validity_period_info: {
          shelf_life_days: null,
          inbound_threshold: null,
          outbound_threshold: null,
          warning_days: null,
          batch_comb_code: ''
        }
      },
      packing_specs: null,
      _import_country_list: []
    };
  };

  AddEditCopyPackaging.prototype.initFormDataRule = function () {
    var _this = this;

    return {
      'basics_info.product_sku': [{
        required: true,
        message: this.t('请输入商品编码')
      }, {
        validator: function validator(rule, value, callback) {
          if (value && !_this.productSkuReg.test(value)) {
            callback(new Error(_this.t('商品编码仅支持数字、字母、_、-、/、小数点、+、*、&以及英文括号，最多80个字符')));
          }

          callback();
        }
      }],
      'basics_info.product_name_cn': [{
        required: true,
        message: this.t('请输入中文名称')
      }, {
        max: 255,
        message: this.t('中文名称不能超过255个字符')
      }],
      'basics_info.product_name_en': [{
        required: true,
        message: this.t('请输入英文名称')
      }, {
        max: 255,
        message: this.t('英文名称不能超过255个字符')
      }, {
        validator: function validator(rule, value, callback) {
          if (value && _this.chineseReg.test(value)) {
            callback(new Error(_this.t('英文名称仅支持输入英文')));
          }

          callback();
        }
      }],
      'basics_info.packaging_type': [{
        required: true,
        message: this.t('请选择包材类型')
      }],
      'spec_info.product_length': [{
        required: true,
        message: this.t('请输入摊平长')
      }, {
        validator: this.sizeValidator(this.t('摊平长'))
      }],
      'spec_info.product_width': [{
        required: true,
        message: this.t('请输入摊平宽')
      }, {
        validator: this.sizeValidator(this.t('摊平宽'))
      }],
      'spec_info.product_height': [{
        required: true,
        message: this.t('请输入摊平高')
      }, {
        validator: this.sizeValidator(this.t('摊平高'))
      }],
      'basics_info.spread_length': [{
        validator: this.spreadSizeValidator(this.t('撑开长'))
      }],
      'basics_info.spread_width': [{
        validator: this.spreadSizeValidator(this.t('撑开宽'))
      }],
      'basics_info.spread_height': [{
        validator: this.spreadSizeValidator(this.t('撑开高'))
      }],
      'spec_info.product_weight': [{
        required: true,
        message: this.t('请输入商品重量')
      }, {
        validator: function validator(rule, value, callback) {
          if (value !== '' && value !== undefined && value !== null) {
            if (Number(value) < _this.weightRange.MIN) {
              callback(new Error("" + _this.t('商品重量必须大于或等于') + _this.weightRange.MIN));
            }

            if (!_this.weightReg.test(String(value))) {
              callback(new Error(_this.t('商品重量必须为数字且最多保留3位小数')));
            }

            if (Number(value) > _this.weightRange.MAX) {
              callback(new Error("" + _this.t('商品重量必须小于或等于') + _this.weightRange.MAX));
            }
          }

          callback();
        }
      }],
      'map_barcode_list.*': [{
        validator: function validator(rule, value, callback) {
          if (!value) {
            return callback();
          }

          if (!_this.barcodeReg.test(value)) {
            return callback(new Error(_this.t('第三方条码仅支持数字、字母、_、-、/、小数点、+、*、&以及英文括号，最多50个字符')));
          }

          var list = (_this.formData.map_barcode_list || []).filter(function (item) {
            return !!item;
          });

          if (list.filter(function (item) {
            return item === value;
          }).length > 1) {
            return callback(new Error(_this.t('第三方条码不能重复')));
          }

          callback();
        }
      }],
      _import_country_list: [{
        required: true,
        type: 'array',
        min: 1,
        message: this.t('请选择国家/地区')
      }]
    };
  };

  AddEditCopyPackaging.prototype.sizeValidator = function (label) {
    var _this = this;

    return function (rule, value, callback) {
      if (value !== '' && value !== undefined && value !== null) {
        if (Number(value) < _this.$enum.product.LengthWidthHeightRange.MIN) {
          callback(new Error("" + label + _this.t('必须大于或等于') + _this.$enum.product.LengthWidthHeightRange.MIN));
        }

        if (!_this.sizeReg.test(String(value))) {
          callback(new Error("" + label + _this.t('必须为数字且最多保留2位小数')));
        }

        if (Number(value) > _this.$enum.product.LengthWidthHeightRange.MAX) {
          callback(new Error("" + label + _this.t('必须小于或等于') + _this.$enum.product.LengthWidthHeightRange.MAX));
        }
      }

      callback();
    };
  };

  AddEditCopyPackaging.prototype.spreadSizeValidator = function (label) {
    var _this = this;

    return function (rule, value, callback) {
      if (!_this.isBox) {
        return callback();
      }

      if (value === '' || value === undefined || value === null) {
        return callback(new Error("" + _this.t('请输入') + label));
      }

      if (Number(value) < _this.$enum.product.LengthWidthHeightRange.MIN) {
        callback(new Error("" + label + _this.t('必须大于或等于') + _this.$enum.product.LengthWidthHeightRange.MIN));
      }

      if (!_this.sizeReg.test(String(value))) {
        callback(new Error("" + label + _this.t('必须为数字且最多保留2位小数')));
      }

      if (Number(value) > _this.$enum.product.LengthWidthHeightRange.MAX) {
        callback(new Error("" + label + _this.t('必须小于或等于') + _this.$enum.product.LengthWidthHeightRange.MAX));
      }

      callback();
    };
  };

  AddEditCopyPackaging.prototype.handlePackagingCategoryChange = function () {
    if (!this.isBox) {
      this.$set(this.formData.basics_info, 'spread_length', '');
      this.$set(this.formData.basics_info, 'spread_width', '');
      this.$set(this.formData.basics_info, 'spread_height', '');
      this.handleClearValidateFields(['basics_info.spread_length', 'basics_info.spread_width', 'basics_info.spread_height']);
    }
  };

  AddEditCopyPackaging.prototype.handleClearValidateFields = function (fields) {
    var formDataRef = this.$refs.formDataRef;

    if (formDataRef) {
      formDataRef.clearValidate(fields);
    }
  };

  AddEditCopyPackaging.prototype.handleMapBarcodeListInput = function (index) {
    if (!this.formData.map_barcode_list) {
      return;
    }

    var str = this.formData.map_barcode_list[index];
    this.formData.map_barcode_list[index] = String(str).toLocaleUpperCase();
  };

  AddEditCopyPackaging.prototype.handleAddMapBarcodeList = function (index) {
    var _a, _b;

    var count = this.customerInfo.third_party_barcode_count;

    if ((((_a = this.formData.map_barcode_list) === null || _a === void 0 ? void 0 : _a.length) || 0) >= count) {
      this.$message.warning(this.t('第三方条码最多只能添加{0}个', [count]));
      return;
    }

    (_b = this.formData.map_barcode_list) === null || _b === void 0 ? void 0 : _b.splice(index + 1, 0, '');
  };

  AddEditCopyPackaging.prototype.handleDeleteMapBarcodeList = function (index) {
    var _a;

    (_a = this.formData.map_barcode_list) === null || _a === void 0 ? void 0 : _a.splice(index, 1);
    this.$forceUpdate();
  };

  AddEditCopyPackaging.prototype.onImageBeforeUpload = function (file) {
    return __awaiter(this, void 0, Promise, function () {
      var formData, res;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            formData = new FormData();
            formData.append('file', file);
            formData.append('file_type', String(this.$enum.product.ProductAttachmentType.IMAGE));
            return [4, this.$api.product.uploadAttachment(formData)];

          case 1:
            res = _a.sent();

            if (res.code === 0) {
              this.formData.image_list.push(res.data);
            }

            return [2];
        }
      });
    });
  };

  AddEditCopyPackaging.prototype.onCheckError = function (type) {
    switch (type) {
      case 'checkExt':
        this.$message.error(this.t('文件格式不符合'));
        break;

      case 'checkSize':
        this.$message.error(this.t('文件大小不符合'));
        break;

      case 'checkLength':
        this.$message.error(this.t('已超过可上传的文件数量'));
        break;
    }
  };

  AddEditCopyPackaging.prototype.handleImageTipMessage = function (msg) {
    this.imageTipMessage = msg;
  };

  AddEditCopyPackaging.prototype.queryImportCountryList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var res;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.common.queryImportCountryList()];

          case 1:
            res = _a.sent();

            if (res.code === 0) {
              this.importCountryList = res.data;
            }

            return [2];
        }
      });
    });
  };

  AddEditCopyPackaging.prototype.getDetail = function () {
    return __awaiter(this, void 0, Promise, function () {
      var sku;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            sku = this.$route.query.sku;
            if (!(sku && typeof sku === 'string')) return [3, 2];
            return [4, this.queryProductDetails({
              sku: sku
            })];

          case 1:
            _a.sent();

            _a.label = 2;

          case 2:
            return [2];
        }
      });
    });
  };

  AddEditCopyPackaging.prototype.queryProductDetails = function (params) {
    return __awaiter(this, void 0, Promise, function () {
      var res, detail, basics, spec;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.product.queryProductDetails(params)];

          case 1:
            res = _a.sent();

            if (res.code !== 0) {
              return [2];
            }

            detail = res.data || {};
            basics = detail.basics_info || {};
            spec = detail.spec_info || {};
            this.formData.product_id = basics.product_id;
            this.formData.product_status = basics.product_status;
            this.formData.basics_info.product_sku = basics.product_sku || '';
            this.formData.basics_info.reference_number = basics.reference_number || '';
            this.formData.basics_info.product_name_cn = basics.product_name_cn || '';
            this.formData.basics_info.product_name_en = basics.product_name_en || '';
            this.formData.basics_info.packaging_type = basics.packaging_type ? Number(basics.packaging_type) : undefined;
            this.formData.basics_info.spread_length = basics.spread_length != null ? String(basics.spread_length) : '';
            this.formData.basics_info.spread_width = basics.spread_width != null ? String(basics.spread_width) : '';
            this.formData.basics_info.spread_height = basics.spread_height != null ? String(basics.spread_height) : '';
            this.formData.spec_info.product_length = spec.product_length != null ? String(spec.product_length) : '';
            this.formData.spec_info.product_width = spec.product_width != null ? String(spec.product_width) : '';
            this.formData.spec_info.product_height = spec.product_height != null ? String(spec.product_height) : '';
            this.formData.spec_info.product_weight = spec.product_weight != null ? String(spec.product_weight) : '';
            this.formData.image_list = detail.image_list || [];
            this.formData.other_info.remark = detail.other_info && detail.other_info.remark || '';

            if (this.isShowMapBarcode) {
              this.formData.map_barcode_list = (detail.map_barcode_list || []).length ? detail.map_barcode_list : [''];
            } else {
              this.formData.map_barcode_list = [];
            }

            this.formData.import_country_list = detail.import_country_list || [];
            this.formData._import_country_list = (detail.import_country_list || []).map(function (item) {
              return item.country_code;
            });

            if (this.type === 'copy') {
              this.formData.basics_info.product_sku = '';
              this.formData.basics_info.reference_number = '';
              this.formData.map_barcode_list = this.isShowMapBarcode ? [''] : [];
              delete this.formData.product_id;
            }

            return [2];
        }
      });
    });
  };

  AddEditCopyPackaging.prototype.handleSubmit = function () {
    var _this = this;

    var formDataRef = this.$refs.formDataRef;
    formDataRef.validate(function (valid) {
      if (!valid) {
        return;
      }

      var formData = _this.setParams();

      switch (_this.type) {
        case 'edit':
          _this.updateProduct(formData);

          break;

        case 'copy':
          delete formData.product_id;

          _this.addProduct(formData);

          break;

        default:
          _this.addProduct(formData);

          break;
      }
    });
  };

  AddEditCopyPackaging.prototype.setParams = function () {
    var formData = this.$util.deepCopy(this.formData);
    formData.basics_info.product_type = this.$enum.product.ProductTypeMap.PACKAGING;
    formData.map_barcode_list = (formData.map_barcode_list || []).filter(function (item) {
      return !!item;
    });
    formData.import_country_list = (formData._import_country_list || []).map(function (code) {
      return {
        country_code: code,
        declared_value: '0.01'
      };
    });
    delete formData._import_country_list;
    formData.export_country_list = (formData.export_country_list || []).map(function (item) {
      return __assign(__assign({}, item), {
        declared_value: '0.01'
      });
    });

    if (formData.basics_info.packaging_type !== this.$enum.product.PackagingCategoryMap.BOX) {
      formData.basics_info.spread_length = '';
      formData.basics_info.spread_width = '';
      formData.basics_info.spread_height = '';
    }

    return formData;
  };

  AddEditCopyPackaging.prototype.addProduct = function (params) {
    return __awaiter(this, void 0, Promise, function () {
      var res;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.product.add(params)];

          case 1:
            res = _a.sent();

            if (res.code === 0) {
              this.$successModal({
                text: this.t('商品[0], 新增成功'),
                textLink: [{
                  text: params.basics_info.product_sku,
                  name: 'ProductDetail',
                  params: {
                    closeCurrent: this.$enum.common.Enabled.YES
                  },
                  query: {
                    sku: params.basics_info.product_sku
                  }
                }],
                btn1: {
                  name: 'AddProductPage',
                  params: {
                    refresh: this.$enum.common.Enabled.YES,
                    noCache: this.$enum.common.Enabled.YES
                  },
                  query: {
                    refreshTime: new Date().getTime()
                  }
                },
                btn2: {
                  name: 'ProductListPage',
                  params: {
                    updateList: this.$enum.common.Enabled.YES,
                    closeCurrent: this.$enum.common.Enabled.YES
                  }
                }
              });
            }

            return [2];
        }
      });
    });
  };

  AddEditCopyPackaging.prototype.updateProduct = function (params) {
    return __awaiter(this, void 0, Promise, function () {
      var res;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.product.update(params)];

          case 1:
            res = _a.sent();

            if (res.code === 0) {
              this.$message.success(this.t('保存成功'));
              this.$router.push({
                name: 'ProductListPage',
                params: {
                  updateList: '1',
                  closeCurrent: '1'
                }
              });
            }

            return [2];
        }
      });
    });
  };

  AddEditCopyPackaging.prototype.created = function () {
    this.setAnchorList();
    this.queryImportCountryList();
    this.getDetail();
  };

  __decorate([Prop({
    type: String,
    "default": 'add'
  })], AddEditCopyPackaging.prototype, "type", void 0);

  __decorate([enumData('Product/PackagingCategoryEnum')], AddEditCopyPackaging.prototype, "packagingCategoryEnum", void 0);

  __decorate([enumData('Product/ProductTypeEnum')], AddEditCopyPackaging.prototype, "productTypeEnum", void 0);

  __decorate([User.State('customerInfo')], AddEditCopyPackaging.prototype, "customerInfo", void 0);

  __decorate([loading('detailLoading')], AddEditCopyPackaging.prototype, "queryImportCountryList", null);

  __decorate([loading('detailLoading')], AddEditCopyPackaging.prototype, "queryProductDetails", null);

  __decorate([loading('addLoading')], AddEditCopyPackaging.prototype, "addProduct", null);

  __decorate([loading('addLoading')], AddEditCopyPackaging.prototype, "updateProduct", null);

  AddEditCopyPackaging = __decorate([Component({
    components: {
      Anchor: Anchor
    }
  })], AddEditCopyPackaging);
  return AddEditCopyPackaging;
}(Vue);

export default AddEditCopyPackaging;